"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function generateBackdrop(map, type) {
    for (var x = 0; x < map.width; x++) {
        for (var y = 0; y < map.height; y++) {
            map.safeWrite(x, y, type);
        }
    }
}
exports.generateBackdrop = generateBackdrop;
